import React, { Component } from "react";

import { Modal, ModalOpen, ModalClose } from '../Modal';
import { AUAContainer } from '../AUA';
import { T } from '../traks';
import API from '../API';
import { Input } from "reactstrap";

function GroupGameModalInit(props) {
  ModalOpen("GroupGameModal", props);
}

class GroupGameInnerContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: props.type || 'create',
      name: '',
      nameError: '',
      loading: false,
    };
  }

  handleCreateGroupClick = () => {
    const { name } = this.state;
    const { gameId, onCreatedGroup } = this.props;

    if (!name) {
      this.setState({ nameError: "invalid" });
      return;
    }
    this.setState({ loading: true });

    API.post('/a/group_game', { name, gameId }, (response) => {
      this.setState({ loading: false });
      if (onCreatedGroup) {
        onCreatedGroup();
      }
      ModalClose();
    });
  };

  handleNameChange = (e) => {
    this.setState({ name: e.target.value, nameError: "" });
  };

  handleRemovePortfolio = () => {
    const {
      game_id,
      group_game_id,
      portfolio_id,
      reload,
      render_static,
    } = this.props;

    const confirmRemove = <T>Are you sure you want to remove this participant?</T>;
    if (!window.confirm(render_static(confirmRemove))) return;

    this.setState({ loading: true });

    API.post(
      "/a/group_game_remove_user",
      { game_id, group_game_id, portfolio_id },
      () => {
        this.setState({ loading: false });
        if (typeof reload === "function") reload();
        ModalClose();
      }
    );
  };

  render() {
    const { type, nameError, name, loading } = this.state;

    if (type === 'create') {
      let nameErrorElement = null;
      if (nameError === "invalid") {
        nameErrorElement = <span><T>Please enter a valid string.</T></span>;
      }

      return (
        <div className="ad_trade_bg p-4">
          <div className="pb-2 py-2">
            <span><T>Enter pool name</T></span>
          </div>
          <Input
            type="text"
            placeholder={this.props.render_static(<T>Pool name</T>)}
            value={name}
            onChange={this.handleNameChange}
          />
          {nameErrorElement && <div className="pb-2 errors">{nameErrorElement}</div>}

          <div className="mt-3 d-flex justify-content-between">
            <button onClick={ModalClose} className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-light-gray">
              <T>Cancel</T>
            </button>
            <button
              onClick={this.handleCreateGroupClick}
              className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light"
              disabled={loading}
            >
              {loading ? <T>Loading...</T> : <T>Create</T>}
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="ad_trade_bg p-4">
        <div className="ad_150pct">
          <b><T>Participant</T></b>
        </div>
        <div className="mt-2">
          <T>Name: </T><span><b className="txt-bold">{this.props.userName}</b></span>
        </div>
        <div className="mt-2">
          <T>Current portfolio value: </T><span><b className="txt-bold">{this.props.currentVal}</b></span>
        </div>
        <div className="mt-3 d-flex justify-content-between">
          <button onClick={ModalClose} className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-light-gray">
            <T>Cancel</T>
          </button>
          <button
            onClick={this.handleRemovePortfolio}
            className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-red"
            disabled={loading}
          >
            {loading ? <T>Loading...</T> : <T>Remove</T>}
          </button>
        </div>
      </div>
    );
  }
}

const GroupGameInner = (props) => <AUAContainer><GroupGameInnerContent {...props}/></AUAContainer>;

class GroupGameModal extends Modal {
    allow_close_via_ui() {
        return true;
    }

    mrender() {
        return <GroupGameInner {...this.props}/>;
    }

    get_name() {
        return "GroupGameModal";
    }

    get_fullscreen_bg_class() {
        return "ad_signuplogin_dark";
    }

    get_fullscreen() {
        return true;
    }
}

export {
    GroupGameModalInit,
    GroupGameModal
}


// WEBPACK FOOTER //
// ./src/c/GroupGameModal.js